// extracted by mini-css-extract-plugin
export var notificationHost = "_gl-0";